<template>
  <div>
    <el-select
      :value="selected"
      @input="dispatch"
      :placeholder="placeholder || $t('message.car_model')"
      filterable
      clearable
      :disabled="disabled"
      :size="size"
      class="d-block"
      :multiple="multiple"
      :class="mode ? 'input__day' : 'input__night'"
    >
      <el-option
        v-for="(carModel, index) in items"
        :key="'guestCarModel-' + index"
        :label="carModel.model"
        :value="carModel.id"
      ></el-option>
    </el-select>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { i18n } from "@/utils/i18n";
export default {
  name: "guest-car-model",
  props: {
    size: {
      default: "small",
    },
    placeholder: {
      default: null,
    },
    id: {
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    guest_car_type_id: {
      default: null,
    },
  },
  data() {
    return {
      selected: null,
    };
  },
  watch: {
    id: {
      handler: function () {
        setTimeout(() => {
          this.selected = this.id;
        });
      },
      deep: true,
      immediate: true,
    },
    guest_car_type_id: {
      handler: function (newVal, oldVal) {
        if (newVal != oldVal) {
          this.selected = null;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.guestCarModels && this.guestCarModels.length === 0) {
      this.updateInventory();
    }
  },
  computed: {
    ...mapGetters({
      guestCarModels: "guestCarModel/inventory",
      mode:'MODE'
    }),
    items: function () {
      if (!this.guest_car_type_id) {
        return this.guestCarModels;
      }
      if (this.guest_car_type_id) {
        let filteredCarModels = _.filter(this.guestCarModels, [
          "guest_car_type_id",
          this.guest_car_type_id,
        ]);
        if (filteredCarModels.length == 1) {
          this.dispatch(filteredCarModels[0].id);
          return filteredCarModels;
        }
        return filteredCarModels;
      }
    },
  },
  methods: {
    ...mapActions({
      updateInventory: "guestCarModel/inventory",
    }),
    dispatch(e) {
      this.$emit("input", e);
      this.selected = e;
    },
  },
};
</script>
